
import { defineComponent, ref } from 'vue'
import PlaceholderImage from '../atoms/PlaceholderImage.vue'

export default defineComponent({
  components: {
    PlaceholderImage
  },
  props: {
    itemIndex: {
      type: Number,
      default: 0
    },
    thumbnailPath: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    }
  },
  setup (props) {
    const hasThumbnail = ref<boolean>(true)
    const notThumbnail = () => {
      hasThumbnail.value = false
    }
    return {
      hasThumbnail,
      notThumbnail,
    }
  }
})
